import { render, staticRenderFns } from "./HabeasDataListComponent.vue?vue&type=template&id=56a55217"
import script from "./HabeasDataListComponent.vue?vue&type=script&lang=js"
export * from "./HabeasDataListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports